import React from 'react';
import { Trans } from 'react-i18next';

import { APP_POLLS } from 'app/common/constants/services';
import IconGood from 'app/components/Subs/icons/IconGood';
import ApplicationNA from './ApplicationNA';
import AppPollsNA from './AppPollsNA';
import enhance from './enhanceNotAssignedList';
import styles from './NotAssignedList.scss';


type Props = {
  unsubsData: Array<Object>,
};

const NotAssignedList = ({ unsubsData }: Props) =>
  <div className={styles.root}>

    {unsubsData.map((data) => {
      if (data.service === APP_POLLS) {
        return <AppPollsNA {...data} />;
      }
      return <ApplicationNA key={data.id} {...data} />;
    })}

    {!unsubsData.length
      && <div className={styles.nothing}>
        <div className={styles.good}>
          <IconGood className={styles.goodIcon} />
        </div>
        <div className={styles.nothingText}>
          <Trans i18nKey="subs:all_connected">
            Все приложения подключены
          </Trans>
        </div>
      </div>
    }

  </div>;

export default enhance(NotAssignedList);
